import * as SentryReact from '@sentry/react';
import { AxiosError } from 'axios-cad-nx';
import { getGlobalProperties } from '../global-properties/global-properties';

export async function setupSentry(options: SentryReact.BrowserOptions = {}): Promise<void> {
    const globalProperties = await getGlobalProperties();

    const { SENTRY_DSN, ENVIRONMENT, VERSION: WEB_OR_RENDERER_VERSION } = globalProperties;

    if (!SENTRY_DSN) {
        return;
    }

    const sentryOptions: Parameters<typeof SentryReact['init']>[0] = {
        dsn: SENTRY_DSN,
        environment: ENVIRONMENT,
        release: WEB_OR_RENDERER_VERSION,
        integrations: [SentryReact.extraErrorDataIntegration()],
        beforeSend(event, hint) {
            const originalException = hint.originalException;
            // filter out AxiosError from cad-next FE sentry
            if (originalException instanceof AxiosError) {
                return null;
            }
            return event;
        },
        // Setting the maximum number of breadcrumbs (anything >100 is treated as 100)
        maxBreadcrumbs: 100,
        // How deep to traverse objects for logging/rendering. Default is 3.
        normalizeDepth: 5,
        // To set a uniform sample rate
        transportOptions: {
            fetchOptions: {
                // This helps us avoid unending pending requests that arise when events
                // or transactions have large payloads
                keepalive: false,
            },
        },
        ...options,
    };
    SentryReact.init(sentryOptions);
}
